// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"066a5feb","976":"01536f94","1107":"267ae081","5697":"01536f94","7058":"066a5feb","9999":"066a5feb"}[chunkId] + ".chunk.css";
};